<div class="sub-header-container">
    <div class="project-breadcrumb-base-container">
        <app-family-projects *ngIf="showProjects"></app-family-projects>
        <app-breadcrumbs *ngIf="showBreadCrumb"></app-breadcrumbs>
        <div class="breadcrumb-seperator"></div>
        <app-family-breadcrumb *ngIf="showFamilyBreadCrumb"></app-family-breadcrumb>
    </div>
    <div class="sub-header-right-container">
        
        <div class="nav-menu-item">
            <a class="nav-menu-center" [class.disabled]="loadingState"
                (click)="!loadingState && openPopup('ReportsMenu')">{{'menu.reports.lbl_reports' | translate}}</a>
        </div>

        <div class="nav-menu-item">
            <a class="nav-menu-item padding-zero">{{'menu.lbl_lists' | translate}}</a>
            <i class="arrow"></i>
            <ol class="nav-sub-item">
                <li class="nav-menu-item nav-menu-center" (click)="openPopup('Multimedia')">
                    {{'menu.resources.lbl_media_list' | translate}}</li>
                    <div class="seperator"></div>
                <li class="nav-menu-item nav-menu-center" (click)="openPopup('IndividualMain')">
                    {{'menu.resources.lbl_member_list' | translate}}</li>
            </ol>
        </div>
         <!-- <app-editors></app-editors> -->
    </div>
</div>